import { Suspense, type ReactNode } from 'react';

// Side-effect import — initializes i18next before any component renders.
import '@/i18n';

/* ─── Loading fallback ─── */
function I18nFallback() {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        blockSize: '100dvh',
        color: 'var(--md-sys-color-on-surface-variant)',
        fontFamily: 'var(--md-sys-typescale-body-font)',
        fontSize: 'var(--md-sys-typescale-body-size)',
      }}
    >
      Loading…
    </div>
  );
}

/* ─── Provider ─── */
interface I18nProviderProps {
  children: ReactNode;
}

/**
 * Wraps children in Suspense so react-i18next can lazily load
 * translation bundles via the HTTP backend.
 */
export function I18nProvider({ children }: I18nProviderProps) {
  return <Suspense fallback={<I18nFallback />}>{children}</Suspense>;
}
